var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 10.9h9.4c.5 0 1-.4 1-.9s-.4-.9-1-.9H4.3l2.8-2.7c.4-.4.4-1 0-1.3-.4-.4-1-.4-1.4 0L1.3 9.2c-.2.1-.3.4-.3.6 0 .3.1.5.3.6l4.4 4.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-.9 0-1.2l-2.8-2.6zM23 14.2c0 .3-.1.5-.3.6l-4.4 4.3c-.2.2-.4.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.3l2.8-2.7h-9.4c-.5 0-1-.4-1-.9s.4-.9 1-.9h9.4l-2.8-2.6c-.4-.4-.4-.9 0-1.2.4-.4 1-.4 1.4 0l4.4 4.3c.2-.1.3.1.3.4z"
  })));
}

export default SvgSwap;